import React from 'react';
import { TextField, Button, MenuItem, Grid, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RepairRequestListParam } from '../../../stores/repairRequestList/api';
import { useSelector } from 'react-redux';
import { isManagerOrAdmin as isManagerOrAdministrator } from '../../../_utils/utils';
import { RootState } from '../../../stores/store';

type SearchResultFormProps = {
  params: RepairRequestListParam;
  updateParams: (params: RepairRequestListParam) => void;
  onClickSearch: () => void;
  onClickClear: () => void;
};

const SearchResultForm: React.FC<SearchResultFormProps> = ({
  params,
  updateParams,
  onClickSearch,
  onClickClear,
}) => {
  const { t } = useTranslation();

  const { userData } = useSelector((state: RootState) => state.userInfo);

  /** メ内サまたは地域管理者権限か */
  const isManagerOrAdmin = isManagerOrAdministrator(userData);

  /** statusの変更 */
  const handleStatusChange = (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>,
  ) => {
    const newStatus = e.currentTarget.dataset.value;
    if (newStatus) {
      updateParams({ ...params, status: Number(newStatus) });
    }
  };

  /** RMA No.とSerial No.変更 */
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    updateParams({
      ...params,
      [name]:
        typeof params[name as keyof RepairRequestListParam] === 'number'
          ? Number(value)
          : value,
    });
  };

  return (
    <Box sx={{ p: 3, pb: 0, mb: 4 }}>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid size={2}>
          <TextField
            fullWidth
            label={t('LBL_RMA_NO')}
            name="rmaNo"
            size="small"
            value={params.rmaNo}
            onChange={handleInputChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        </Grid>
        <Grid size={2}>
          <TextField
            fullWidth
            label={t('LBL_SERIAL_NO')}
            name="serialNo"
            size="small"
            value={params.serialNo}
            onChange={handleInputChange}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
        </Grid>
        {isManagerOrAdmin && (
          <Grid size={2}>
            <TextField
              fullWidth
              label={t('LBL_PROGRESS')}
              name="status"
              size="small"
              value={params.status}
              select
              onChange={handleInputChange}
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            >
              <MenuItem value="2" onClick={handleStatusChange}>
                &nbsp;{/* 空の選択肢 */}
              </MenuItem>
              <MenuItem value="0" onClick={handleStatusChange}>
                {t('LBL_IN_PROGRESS')}
              </MenuItem>
              <MenuItem value="1" onClick={handleStatusChange}>
                {t('LBL_COMPLETED')}
              </MenuItem>
            </TextField>
          </Grid>
        )}
        {/* 検索とクリアボタン */}
        <Grid size={3}>
          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={onClickSearch}
              fullWidth
            >
              {t('BTN_SEARCH')}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClickClear}
              fullWidth
            >
              {t('BTN_CLEAR')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchResultForm;
